import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "not-found",
  templateUrl: "not-found.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class NotFoundComponent {}
